import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './u-boot.css'

const UBoot = (props) => {
  return (
    <div className="u-boot-container1">
      <Helmet>
        <title>U-Boot Ehrendenkmal Kiel - marjangerrits.nl</title>
        <meta
          name="description"
          content="Herdenking Gerhard Woltjes omgekomen in een onderzeeër in de Tweede Wereldoorlog."
        />
        <meta
          property="og:title"
          content="U-Boot Ehrendenkmal Kiel - marjangerrits.nl"
        />
        <meta
          property="og:description"
          content="Herdenking Gerhard Woltjes omgekomen in een onderzeeër in de Tweede Wereldoorlog."
        />
      </Helmet>
      <NavbarInteractive rootClassName="navbar-interactiveroot-class-name12"></NavbarInteractive>
      <div className="u-boot-container2">
        <div className="u-boot-container3">
          <img
            alt="image"
            src="/ehrendenkmal%20klein-700w.jpg"
            className="u-boot-foto1"
          />
          <div className="u-boot-container4">
            <span className="u-boot-titel">Stilstaan in Duitsland</span>
            <p className="u-boot-datum">
              <span>04-07-2023</span>
              <br></br>
            </p>
            <p className="u-boot-text12">
              We staan letterlijk stil als we het U-Boot-Ehrendenkmal (U van
              Untersee) vlakbij Kiel inlopen. Zo veel herdenkingsstenen. Rijen
              met nummers van gezonken onderzeeërs in de Eerste en Tweede
              Wereldoorlog en daaronder de namen van bemanningsleden. Een goed
              verzorgde plek, voor elke steen dezelfde pot met bloeiende
              planten. Ik beperk me tot de informatie over de Tweede
              Wereldoorlog en lees dat er 739 U-Boten en 30.003 bemanningsleden
              omgekomen zijn.
            </p>
          </div>
        </div>
        <p className="u-boot-text13">
          <br></br>
          <span>
            We zijn hier niet voor niets. We zoeken de naam van mijn partners
            oom, Onkel Gerhard. Gelukkig weten we het nummer van de U-Boot
            waarin hij zat, dat vergemakkelijkt het zoeken. Als we hem gevonden
            hebben staan we opnieuw stil. Je weet dat oorlog een en al ellende
            is, maar hier voel je het tot in je tenen. Al die jonge mannen,
            meest twintigers. De kapitein was nog maar vierendertig. Hoe was het
            leven van die jongens in een onderzeeër? Je kunt je er nauwelijks
            een voorstelling van maken.
          </span>
          <br></br>
          <br></br>
        </p>
        <div className="u-boot-container5">
          <div className="u-boot-container6">
            <p className="u-boot-text18">
              De volgende dag gaan we naar Laboe waar we een onderzeeër van
              binnen kunnen bekijken. Hier krijgen we wel een beeld van het
              leven in zo&apos;n U-Boot. Een lange, smalle, bijna
              claustrofobische ruimte waar tientallen matrozen wekenlang, soms
              maandenlang, moesten leven. Nu was de temperatuur prima, maar toen
              was het er warm, vochtig, geen stromend water. Een minikeuken waar
              amper iets klaargemaakt kon worden. Ze zullen veel blikvoer
              gegeten hebben denk ik. Smalle harde bedden naast en boven de
              torpedo’s. En dan de dreiging van een geallieerde aanval zonder
              kans op ontsnapping. A hell of a job.
            </p>
          </div>
          <div className="u-boot-container7">
            <img
              alt="image"
              src="/Blog foto's/u-boot%20smal%20klein-700w.jpg"
              className="u-boot-foto2"
            />
          </div>
        </div>
        <p className="u-boot-text19">
          <br></br>
          <span>
            Onkel Gerhard werd, na een training van een halfjaar, begin november
            1943 ingezet in de U-bootoorlog. Hij zat in de U544, die deel
            uitmaakte van een konvooi. Ze voeren via Kiel en twee tussenstops
            naar Bergen in Noorwegen en vandaar door de Noordzee naar de
            Atlantische oceaan. Ze kwamen geen vijandelijke schepen tegen, in
            actie hoefden ze niet te komen. Een maand na zijn vertrek werd hij
            21 jaar. Het werd zijn laatste verjaardag. Inmiddels was de
            enigmacode gekraakt en wisten de geallieerden waar de Duitse
            onderzeeërs zich bevonden. In januari 1944, na 68 dagen op zee,
            werden ze tijdens het tanken gespot door de geallieerden en door
            raketten en waterbommen aangevallen.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <br></br>
          <span>
            Later thuis lees ik dat een aantal bemanningsleden nog het water in
            kon springen. Zou Onkel Gerhard daarbij gezeten hebben? Hij was een
            goede zwemmer. Toch heeft niemand het overleefd. De diesel die
            getankt werd kwam door de aanval in zee terecht. Kwamen ze daarin
            terecht? Was dat de oorzaak? We zullen het nooit precies weten. Maar
            we leven, bijna tachtig jaar later, postuum met de families mee.
          </span>
          <br></br>
        </p>
      </div>
      <div className="u-boot-andere-blogs">
        <h2 className="u-boot-lees-ook">
          <span>Lees ook:</span>
          <br></br>
        </h2>
        <div className="u-boot-laatste3-blogposts"></div>
      </div>
      <Footer rootClassName="footerroot-class-name13"></Footer>
      <a
        href="https://example.com"
        target="_blank"
        rel="noreferrer noopener"
        className="u-boot-link"
      >
        Link
      </a>
    </div>
  )
}

export default UBoot
